import { requestQuote } from './helper/api';

const loadBadges = async (trello) => {
  // must be a known Trello user, otherwise we can't get a JWT
  if (!trello.isMemberSignedIn()) {
    return [];
  }

  const board = await trello.board('customFields');
  const tickerField = board.customFields?.find((cf) => cf.name.toLowerCase() === 'ticker');
  if (!tickerField) {
    return [];
  }
  const card = await trello.card('customFieldItems');
  const tickerSymbol = card.customFieldItems?.find((cfi) => cfi.idCustomField === tickerField.id);
  if (!tickerSymbol) {
    return [];
  }

  return [
    {
      dynamic: async function () {
        const jwt = await trello.jwt();
        let data;
        try {
          data = await requestQuote(tickerSymbol.value.text, jwt);
        } catch (err) {
          return null;
        }

        if (typeof data?.latestPrice === 'number') {
          return {
            text: `$${data.latestPrice.toFixed(2)}`,
            title: 'Price',
            refresh: 60,
          };
        }
        return null;
      },
    },
    {
      dynamic: async function () {
        const jwt = await trello.jwt();
        let data;
        try {
          data = await requestQuote(tickerSymbol.value.text, jwt);
        } catch (err) {
          return null;
        }

        if (typeof data?.latestPrice === 'number') {
          return {
            color: data.change >= 0 ? 'green' : 'red',
            text: `${(data.changePercent * 100).toFixed(1)}%`,
            title: 'Change',
            refresh: 60,
          };
        }
        return null;
      },
    },
  ];
};

window.TrelloPowerUp.initialize({
  'card-badges': loadBadges,
  'card-detail-badges': loadBadges,
});
